<script setup lang="ts">
export interface CiErrorProps {
  message: string;
}
const props = withDefaults(defineProps<CiErrorProps>(), {});

const { $gettext } = useGettext();
</script>

<template>
  <div class="text-center">
    <CiAnimatedCross class="mx-auto max-w-20 md:max-w-52 lg:max-w-44" />
    <h3 class="mt-6">
      {{ $gettext('Uh oh.') }}
    </h3>
    <div v-html="props.message" />
  </div>
</template>
